export enum ErrorCode {
  InvalidPhone = 100,
  PatientDoesNotExist = 101,
  DuplicatePhone = 102,
  DuplicateMrn = 103,
  OverlappingCallIntervals = 104,
  InvalidEmail = 105,
  InvalidRequest = 106,
  DuplicationError = 107,
  DoctorDoesNotExist = 108,
  TicketDoublePickup = 109,
  ResolveTicketConflict = 'RESOLVE_TICKETS_CONFLICT',
  InvalidClinicianRoleUpdate = 'INVALID_CLINICIAN_ROLE_UPDATE',
  ResolveClosedTicket = 'RESOLVE_CLOSED_TICKET',
  EpisodeDuplicateNameException = 800,
  EpisodeInvalidDurationException = 801,
  DuplicateEpisodeEndReason = 802,
  DuplicateReason = 803,
  OperatorTicketTypeAllowanceError = 804,
  WrongPatientTag = 111,
  MissingMrn = 112,
  EnrollEnrolledCMEpisode = 113,
  ThoughtSpotError = 114,
  UpdateCMStatus = 115,
  InvalidCredentials = 116,
  NotValidPhoneForSms = 117,
  TimerIntervalNotWithinAllowedRange = 118,
  SsoAuthenticatedButNotRegistered = 119,
  PatientFeatureNotAllowed = 120,
  PatientProviderMissing = 121,
  TicketSubTypeNameExists = 122,
  TicketSubTypeTranslationNameExists = 123,
  TicketConnectedToDraft = 124,
  ThoughtSpotNewUserError = 125,
  PatientDobMismatch = 126,
  BulkInviteInProgress = 127,
  SummaryCharacterLimit = 128,
  LandlineInsteadMobile = 129,
  UserUnsubscribedFromSms = 130,
  GenericSmsError = 131,
  DuplicateRoleError = 132,
  DuplicateEmrPatientFound = 133,
  NoDuplicateEmrPatientFound = 134,
  ResolvingUnreadInboundMessages = 135,
  ResolvingFailedOutboundMessages = 136,
  ResolvingPendingOutboundMessages = 137,
  PatientCannotReplyAfterTicketResolve = 138,
  MultipleDuplicateEmrPatientFound = 139,
  DuplicateEmail = 140,
  MultipleSettingsEntriesFoundForInstitution = 141,
  InstitutionSettingsNotFound = 142,
  NotOperatorTicket = 143,
  PatientSMSRecentlySent = 144,
  PatientPhoneNumberNotFound = 145,
  PatientOptOut = 146,
  PatientConversationAlreadyOpen = 147
}
